import React, { Component, Fragment, SyntheticEvent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { History } from 'history'

import { fetchRefiTransaction } from './refiTransactionsActions'
import { selectRefiTransaction } from '../../reducers'
import { RefiTransaction } from './types'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import Loader from '../../components/loader'

import { createRefiStipulation } from '../refiApp/refiActions'
import RefiCustomToDoForm from '../../components/refiCustomToDoForm'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchRefiTransaction: Callback<Promise<any>>
  createRefiStipulation: Callback<Promise<any>>
  refiTransaction: RefiTransaction
  match: Match<ParamsID>
  history: History
}

export class refiTransactionsCustomTodo extends Component<Props> {
  static displayName = 'refiTransactionsCustomTodo'

  state = {
    isLoading: false,
    title: null,
    description: null,
    mode: 'image',
  }

  componentWillMount() {
    this.fetchRefi()
  }

  onTitleChange = (evt: SyntheticEvent) => {
    const element = evt.currentTarget as HTMLInputElement
    this.setState({ title: element.value })
  }

  onDescriptionChange = (evt: SyntheticEvent) => {
    const element = evt.currentTarget as HTMLInputElement
    this.setState({ description: element.value })
  }

  onModeChange = (evt: SyntheticEvent) => {
    const element = evt.currentTarget as HTMLSelectElement
    this.setState({ mode: element.value })
  }

  fetchRefi = () => {
    const { fetchRefiTransaction, match } = this.props
    fetchRefiTransaction(match.params && match.params.id)
  }

  onSubmit = () => {
    const { match, history, createRefiStipulation } = this.props

    const toSubmit = {
      id: Number(match.params.id),
      stipulation: {
        title: this.state.title,
        description: this.state.description,
        mode: this.state.mode,
        custom_todo: true,
      },
    }

    this.setState({ isLoading: true })

    return createRefiStipulation(toSubmit)
      .then(() => {
        history.push({ pathname: `/refinance/${match.params.id}` })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  backToIndex = () => {
    this.props.history.goBack()
  }

  render() {
    const { isLoading } = this.state

    const customToDoFormProps = {
      onSubmit: this.onSubmit,
      cancel: this.backToIndex,
      onTitleChange: this.onTitleChange,
      onDescriptionChange: this.onDescriptionChange,
      onModeChange: this.onModeChange,
    }

    return (
      <Fragment>
        <TransitionGroup>
          {isLoading && (
            <CSSTransition
              classNames="slow-fade"
              timeout={{
                enter: 200,
                exit: 500,
              }}
            >
              <div className="loading-overlay">
                <Loader isLoading={true} className="loading-overlay__loader" />
                <p className="loading-overlay__text">
                  Please wait... It will take a minute.
                </p>
              </div>
            </CSSTransition>
          )}
        </TransitionGroup>
        <RefiCustomToDoForm {...customToDoFormProps} />
      </Fragment>
    )
  }
}

const mapStateToProps = (state, { match }) => {
  return {
    refiTransaction: selectRefiTransaction(
      state.refiTransactions,
      match.params.id
    ),
  }
}

const mapDispatchToProps = (dispatch) => ({
  createRefiStipulation: (stipulation) =>
    dispatch(createRefiStipulation(stipulation)),
  fetchRefiTransaction: (id) => dispatch(fetchRefiTransaction(id)),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(refiTransactionsCustomTodo)
)
